export enum ColumnType {
  String = 'String',
  Button = 'Button',
  UtcToLocal = 'UtcToLocal',
  TimeSpent = 'TimeSpent',
  Delete = 'Delete',
  NoteButton = 'NoteButton',
  Preview = 'Preview',
  RestoreButton = 'RestoreButton'
}
